import { render } from "./COIActionBarMakeRequest.vue?vue&type=template&id=7a3641a2"
import script from "./COIActionBarMakeRequest.vue?vue&type=script&lang=js"
export * from "./COIActionBarMakeRequest.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__